<app-public-header></app-public-header>

<div class="welcome-wrap">
  <p>You were logged out due to inactivity.</p>
  <div class="text-center">
    <span>Go back to <a [routerLink]="'/login'">Login here</a></span>
  </div>
</div>

<app-public-footer></app-public-footer>
